import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ApplicationFormSection } from 'src/components/WebFormApplication/ApplicationFormSection';
import WebFormAws from 'src/components/WebFormAws/WebFormAws';
import WebFormAwsVoucher from 'src/components/WebFormAwsVoucher/WebFormAwsVoucher';
import WebFormRequestAnOffer from 'src/components/WebFormRequestAnOffer/WebFormRequestAnOffer';
import { ContactFormSection } from '../ContactFormSection/ContactFormSection';
import { ContactFormWithAnimation } from '../ContactFormWithAnimation/ContactFormWithAnimation';
import { WebFormWithQueryClient } from 'src/components/WebFormWrapper';

const webForms = (formData) => [
  { component: <ContactFormWithAnimation {...formData} />, id: 'contactFormWithAnimation', type: 'contactFormWithAnimation' },
  { component: <ContactFormSection {...formData} />, id: 'contactFormSection', type: 'contactFormSection' },
  { component: <WebFormRequestAnOffer />, id: 'requestAnOffer', type: 'requestAnOffer' },
  { component: <ApplicationFormSection />, id: 'application', type: 'application' },
  {
    component: (
      <WebFormWithQueryClient>
        <WebFormAws />
      </WebFormWithQueryClient>
    ),
    id: 'awsBook',
    type: 'awsBook',
  },
  {
    component: (
      <WebFormWithQueryClient>
        <WebFormAwsVoucher />
      </WebFormWithQueryClient>
    ),
    id: 'awsVoucher',
    type: 'awsVoucher',
  },
];
export const ContactForms = ({ forms }) => {
  const selectedForms = forms
    .map((form) => {
      const matchingWebForm = webForms(form[form.type]).find((webForm) => webForm.type === form.type);

      if (matchingWebForm) {
        return { ...form, ...matchingWebForm };
      }
      return null;
    })
    .filter((e) => !!e);

  const [active, setActive] = useState(selectedForms[0]?.id);
  const handleClick = (event) => {
    setActive(event.target.value);
  };

  if (!forms.length) return null;

  const activeForm = selectedForms.find((e) => e.id === active).component;

  return (
    <Container fluid className="bg-gray-800 px-0">
      <Container>
        <Row>
          <Col xs={12} md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
            {selectedForms.length > 1 && (
              <Col xs={12}>
                <Row className="justify-content-center">
                  {selectedForms
                    .filter((t) => t.tab)
                    .map((e) => (
                      <Col xs="auto" key={e.id} className="pt-5">
                        <button
                          type="button"
                          onClick={handleClick}
                          onFocus={handleClick}
                          value={e.id}
                          style={{
                            appearance: 'none',
                            backgroundColor: 'transparent',
                            border: '0',
                            outline: 'none',
                          }}
                          className={['btn-link-secondary', active === e.id ? 'active' : null].join(' ').trim()}
                        >
                          {e.tab}
                        </button>
                      </Col>
                    ))}
                </Row>
              </Col>
            )}
          </Col>
        </Row>
      </Container>

      <Container id="contact" fluid className="active animate_base animate_fadeInUp px-0">
        {activeForm}
      </Container>
    </Container>
  );
};
